import { useEffect } from 'react';

let refCount = 0;
let removeListener: (() => void) | null = null;

const install = () => {
  if (typeof window === 'undefined' || !window.visualViewport) return;

  const viewport = window.visualViewport;
  let frame: number | null = null;

  const write = () => {
    frame = null;
    const inset = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop);
    document.documentElement.style.setProperty('--keyboard-inset-bottom', `${inset}px`);
  };

  const schedule = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(write);
  };

  write();
  viewport.addEventListener('resize', schedule);
  viewport.addEventListener('scroll', schedule);

  removeListener = () => {
    if (frame !== null) window.cancelAnimationFrame(frame);
    viewport.removeEventListener('resize', schedule);
    viewport.removeEventListener('scroll', schedule);
    document.documentElement.style.removeProperty('--keyboard-inset-bottom');
  };
};

export const useKeyboardInset = () => {
  useEffect(() => {
    if (refCount === 0) install();
    refCount += 1;
    return () => {
      refCount -= 1;
      if (refCount === 0 && removeListener) {
        removeListener();
        removeListener = null;
      }
    };
  }, []);
};
